import { IAction, type IStep } from "@chainlit/react-client";

import CopyButton from "@/components/CopyButton";

interface Props {
  message: IStep;
  actions: IAction[];
  run?: IStep;
}

const MessageButtons = ({ message, actions, run }: Props) => {
  const isUser = message.type === "user_message";
  const isAsk = message.waitForAnswer;
  const hasContent = !!message.output;
  const showCopyButton = !!run && hasContent && !isUser && !isAsk;

  const messageActions = actions.filter((a) => a.forId === message.id);

  const show = showCopyButton || messageActions?.length;

  if (!show || message.streaming) {
    return null;
  }

  return (
    <div className="-ml-1.5 flex items-center flex-wrap">
      {showCopyButton ? <CopyButton content={message.output} /> : null}
    </div>
  );
};

export { MessageButtons };
